/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbResultatTypeGridDto } from './FcbResultatTypeGridDto';
import {
    FcbResultatTypeGridDtoFromJSON,
    FcbResultatTypeGridDtoFromJSONTyped,
    FcbResultatTypeGridDtoToJSON,
} from './FcbResultatTypeGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbResultatTypeGridDtoPaginatedResults
 */
export interface FcbResultatTypeGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbResultatTypeGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbResultatTypeGridDto>}
     * @memberof FcbResultatTypeGridDtoPaginatedResults
     */
    results?: Array<FcbResultatTypeGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbResultatTypeGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbResultatTypeGridDtoPaginatedResults interface.
 */
export function instanceOfFcbResultatTypeGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbResultatTypeGridDtoPaginatedResultsFromJSON(json: any): FcbResultatTypeGridDtoPaginatedResults {
    return FcbResultatTypeGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbResultatTypeGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbResultatTypeGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbResultatTypeGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbResultatTypeGridDtoPaginatedResultsToJSON(value?: FcbResultatTypeGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbResultatTypeGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

